import React from 'react';
import { getWeekLabel } from '../utils/sessionUtils';

export default function CohortDetail({
  selectedCohort,
  cohortDetailTab,
  sessions,
  auditors,
  allStudents,
  currentUser,
  spocTasks,
  setCohortDetailTab,
  setSelectedCohort,
  setActiveTab,
  handleStartSessionForm,
  handleOpenOutcomeForm,
  onSessionClick,
  setNominationsCohortId,
  setNomChairId,
  setNomPresenter1,
  setNomPresenter2,
  setNomPresenter3,
  setNomPresenter4,
  setNomMentor1,
  setNomMentor2,
  setNomMentor3,
  setNomMentor4,
  setShow4thPresenter,
  setShow4thMentor,
  spocPickerOpen,
  setSpocPickerOpen,
  schoolSpocs,
  onAssignSpoc,
  onUnassignSpoc,
  onUpdateLevelYear,
  onStudentClick,
}) {
  const hasSpoc = !!selectedCohort.spocId;
  const isPA = currentUser?.role === 'program_administrator';
  const resolvedSpocName = hasSpoc
    ? (
        selectedCohort.spocName
        || schoolSpocs.find(t => String(t.id) === String(selectedCohort.spocId))?.name
        || (
          currentUser?.role === 'spoc'
          && String(selectedCohort.spocId) === String(
            currentUser.apiUser?.user_id
            || currentUser.apiUser?.id
            || currentUser.apiUser?.sub
            || ''
          )
            ? (currentUser.name || currentUser.email)
            : null
        )
        || `SPOC #${selectedCohort.spocId}`
      )
    : null;

  return (
    <div className="animate-fade-in">
      <button className="btn-back-link" onClick={() => {
        setSelectedCohort(null);
        const backTab = currentUser?.role === 'spoc' ? 'my_cohorts' : 'cohorts';
        setActiveTab(backTab);
        window.location.hash = `#/${backTab}`;
      }}>
        {currentUser?.role === 'spoc' ? '← Back to My Cohorts' : '← Back to Operations Console'}
      </button>

      <div className="detail-header-card">
        <div className="detail-header-left">
          <h1 className="detail-cohort-title">{selectedCohort.name}</h1>
          <div className="detail-cohort-meta-row">
            <span>School: <strong>{selectedCohort.schoolName}</strong></span>
            <span>
              SPOC: <strong>{hasSpoc ? resolvedSpocName : <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>Not assigned</span>}</strong>
              {isPA && (
                <>
                  {hasSpoc && (
                    <button
                      className="btn-inline-action"
                      style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 8px', color: 'var(--error, #d32f2f)', borderColor: 'var(--error, #d32f2f)' }}
                      onClick={() => onUnassignSpoc(selectedCohort.id)}
                      title="Unassign SPOC"
                    >
                      ✕ Unassign
                    </button>
                  )}
                  <button
                    className="btn-inline-action"
                    style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 8px' }}
                    onClick={() => setSpocPickerOpen(true)}
                  >
                    {hasSpoc ? 'Change' : 'Assign SPOC'}
                  </button>
                </>
              )}
            </span>
            <span>
              Programme Year:{' '}
              {isPA ? (
                <select
                  className="wizard-select"
                  value={selectedCohort.levelYear ?? ''}
                  onChange={(e) => onUpdateLevelYear && onUpdateLevelYear(selectedCohort.id, e.target.value)}
                  style={{ display: 'inline-block', width: 'auto', minWidth: '220px', marginLeft: '8px' }}
                >
                  <option value="" disabled>— Select Programme Year —</option>
                  <option value="Year 1">Year 1 - Glosco Councils</option>
                  <option value="Year 2">Year 2 - Glosco Policy Studio</option>
                </select>
              ) : (
                <strong>{selectedCohort.levelYear || '—'}</strong>
              )}
            </span>
            <span>Status: <span className="status-pill active">{selectedCohort.status}</span></span>
          </div>
        </div>
        <div className="detail-header-right">
          {selectedCohort.status === 'Active' && isPA && (
            <span title={!hasSpoc ? 'Assign a SPOC first before planning sessions' : undefined}>
              <button
                className="btn-create-cohort"
                disabled={!hasSpoc}
                style={!hasSpoc ? { opacity: 0.45, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                onClick={() => handleStartSessionForm(selectedCohort.id)}
              >
                Plan New Session
              </button>
            </span>
          )}
        </div>
      </div>

      {spocPickerOpen && isPA && (
        <div className="modal-overlay" onClick={() => setSpocPickerOpen(false)}>
          <div className="modal-card" style={{ maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ margin: 0 }}>Assign SPOC</h3>
              <button className="modal-close-btn" onClick={() => setSpocPickerOpen(false)}>×</button>
            </div>
            <div style={{ padding: '16px' }}>
              {schoolSpocs.length === 0 ? (
                <p style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>No teachers found for this school. Open the school in the Schools tab first to load teachers.</p>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {schoolSpocs.map(spoc => (
                    <button
                      key={spoc.id}
                      className={`spoc-picker-row ${selectedCohort.spocId === spoc.id ? 'selected' : ''}`}
                      style={{
                        display: 'flex', alignItems: 'center', gap: '10px',
                        padding: '10px 14px', border: '1px solid var(--border)',
                        borderRadius: '8px', background: selectedCohort.spocId === spoc.id ? 'var(--primary-light)' : 'white',
                        cursor: 'pointer', textAlign: 'left', fontSize: '14px',
                      }}
                      onClick={() => onAssignSpoc(selectedCohort.id, spoc.id, spoc.name)}
                    >
                      <span style={{ fontWeight: 600, flex: 1 }}>{spoc.name}</span>
                      {selectedCohort.spocId === spoc.id && <span style={{ color: 'var(--primary-navy)', fontSize: '12px' }}>Current</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="tabs-navigation-row">
        <button
          className={`tab-nav-button ${cohortDetailTab === 'students' ? 'active' : ''}`}
          onClick={() => setCohortDetailTab('students')}
        >
          Enrolled Students ({(selectedCohort.studentIds || []).length})
        </button>
        <button
          className={`tab-nav-button ${cohortDetailTab === 'sessions' ? 'active' : ''}`}
          onClick={() => setCohortDetailTab('sessions')}
        >
          Fellowship Sessions ({sessions.filter(s => s.cohortId === selectedCohort.id).length})
        </button>
        {currentUser?.role === 'spoc' && (
          <button
            className={`tab-nav-button ${cohortDetailTab === 'tasks' ? 'active' : ''}`}
            onClick={() => setCohortDetailTab('tasks')}
          >
            Pending Tasks ({spocTasks.filter(t => t.cohortId === selectedCohort.id).length})
          </button>
        )}
      </div>

      {cohortDetailTab === 'students' && (
        <div className="tab-panel-container students-table-card">
          <table className="students-table">
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Academic Grade</th>
              </tr>
            </thead>
            <tbody>
              {(selectedCohort.studentIds || []).length === 0 && (
                <tr><td colSpan={2} style={{ textAlign: 'center', padding: '24px', color: 'var(--text-muted)', fontStyle: 'italic' }}>No students enrolled yet.</td></tr>
              )}
              {(selectedCohort.studentIds || []).map(id => {
                const stud = allStudents.find(s => String(s.id) === String(id));
                return (
                  <tr key={id}>
                    <td>
                      {stud ? (
                        (currentUser?.role === 'program_administrator' || currentUser?.role === 'counselor') ? (
                          <button
                            onClick={() => onStudentClick && onStudentClick(stud)}
                            style={{
                              background: 'none',
                              border: 'none',
                              padding: 0,
                              color: 'var(--primary-navy, #0147a2)',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              textAlign: 'left',
                              fontWeight: 600
                            }}
                          >
                            {stud.name}
                          </button>
                        ) : (
                          <span>{stud.name}</span>
                        )
                      ) : (
                        <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>Loading…</span>
                      )}
                    </td>
                    <td>{stud ? stud.grade : '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {cohortDetailTab === 'sessions' && (
        <div className="tab-panel-container">
          {sessions.filter(s => s.cohortId === selectedCohort.id).length > 0 ? (() => {
            const cohortSessGroups = (() => {
              const sorted = sessions.filter(s => s.cohortId === selectedCohort.id).sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
              const groups = {};
              sorted.forEach(s => {
                const label = getWeekLabel(s.scheduledAt);
                if (!groups[label]) groups[label] = [];
                groups[label].push(s);
              });
              return groups;
            })();
            return Object.keys(cohortSessGroups).map(weekLabel => (
              <div key={weekLabel} className="timeline-week-group">
                <div className="timeline-week-header">
                  <span>{weekLabel}</span>
                </div>
                <div className="timeline-grid">
                  {cohortSessGroups[weekLabel].map(session => (
                    <div
                      key={session.id}
                      className="timeline-session-card"
                      onClick={() => onSessionClick && onSessionClick(session)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="session-card-header">
                        <div>
                          <span className="session-card-type">
                            {session.status === 'Completed' && (
                              <span style={{ color: '#15803d', marginRight: '4px' }}>✓</span>
                            )}
                            {session.status === 'Cancelled' && (
                              <span style={{ color: '#b91c1c', marginRight: '4px' }}>✗</span>
                            )}
                            {session.sessionType}
                          </span>
                          <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
                            {session.scheduledAt.replace('T', ' ')}
                          </div>
                        </div>
                        <span className={`status-pill ${session.status.toLowerCase()}`}>{session.status}</span>
                      </div>

                      <div className="session-card-meta">
                        <div>🕒 Slot: <strong>{session.timeSlot}</strong></div>
                        <div style={{ marginTop: '4px' }}>🔗 Zoom: <a href={session.meetingLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }} onClick={(e) => e.stopPropagation()}>Join Room</a></div>
                        {session.comments && <div style={{ marginTop: '8px', fontStyle: 'italic', fontSize: '11.5px', color: 'var(--neutral-500)' }}>"{session.comments}"</div>}
                      </div>

                      <div className="session-card-footer">
                        <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Assigned Auditors:</span>
                        <div className="session-card-auditors">
                          {(session.auditors || []).map(audId => {
                            const aud = auditors.find(a => a.id === audId);
                            const assignmentObj = (selectedCohort.auditorAssignments || []).find(a => a.auditorId === audId);
                            const isStandby = assignmentObj ? assignmentObj.isStandby : false;
                            return (
                              <span key={audId} className={`auditor-avatar-pill ${isStandby ? 'standby' : ''}`}>
                                {aud ? aud.name : 'Auditor'} {isStandby ? '(Standby)' : ''}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ));
          })() : (
            <div className="empty-state-card" style={{ padding: '48px 24px', borderStyle: 'solid' }}>
              <div className="empty-state-icon-wrapper" style={{ width: '60px', height: '60px', fontSize: '24px' }}>
                <span>📅</span>
              </div>
              <h3 className="empty-state-heading" style={{ fontSize: '16px' }}>No sessions planned</h3>
              <p className="empty-state-description" style={{ fontSize: '13px', marginBottom: '16px' }}>
                There are currently no orientation or council sessions scheduled for this cohort.
              </p>
              <button
                className="btn-create-cohort"
                style={{ padding: '8px 18px', fontSize: '13px' }}
                onClick={() => handleStartSessionForm(selectedCohort.id)}
              >
                Plan First Session
              </button>
            </div>
          )}
        </div>
      )}

      {cohortDetailTab === 'tasks' && currentUser?.role === 'spoc' && (
        <div className="tab-panel-container">
          {spocTasks.filter(t => t.cohortId === selectedCohort.id).length > 0 ? (
            <div className="pending-tasks-grid" style={{ gridTemplateColumns: '1fr', gap: '16px' }}>
              {spocTasks
                .filter(t => t.cohortId === selectedCohort.id)
                .map(task => {
                  const isRed = task.timeLeftHours < 12;
                  return (
                    <div
                      key={task.id}
                      className={`task-countdown-card clickable ${isRed ? 'red-alert' : 'amber-alert'}`}
                      onClick={() => {
                        if (task.type === 'post_session_log') {
                          handleOpenOutcomeForm(task.sessionId);
                        } else if (task.type === 'nominations') {
                          setNominationsCohortId(task.cohortId);
                          setNomChairId('');
                          setNomPresenter1('');
                          setNomPresenter2('');
                          setNomPresenter3('');
                          setNomPresenter4('');
                          setNomMentor1('');
                          setNomMentor2('');
                          setNomMentor3('');
                          setNomMentor4('');
                          setShow4thPresenter(false);
                          setShow4thMentor(false);
                          setSelectedCohort(null);
                          setActiveTab('nominations');
                          window.location.hash = '#/nominations';
                        }
                      }}
                      style={{ cursor: 'pointer', padding: '20px', borderLeft: '4px solid' }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 'bold' }}>{task.title}</h3>
                          <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: 'var(--neutral-600)' }}>
                            {task.sessionName}
                          </p>
                        </div>
                        <span className={`task-badge-pill ${isRed ? 'red' : 'amber'}`}>
                          ⏰ {task.timeLeftHours}h left
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className="empty-state-card">
              <div className="empty-state-icon-wrapper" style={{ color: '#10b981', background: 'rgba(16, 185, 129, 0.1)' }}>
                <span>✓</span>
              </div>
              <h2 className="empty-state-heading">All tasks completed</h2>
              <p className="empty-state-description">No pending tasks or action logs required for this cohort.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
